<template>
  <el-dialog
    :visible.sync = 'isVisible'
    :title="tijianLimitTitle"
    width="1000px"
    append-to-body
    :close-on-click-modal="false"
  >
    <div>
      <h3 style="text-align: center;">普通高等学校招生体检工作指导意见</h3>
      <h4>一、合格</h4>
      <h4>二、	患有下列疾病者，学校可不予录取</h4>
      1.严重心脏病(先天性心脏病经手术治愈，或房室间隔缺损分流量少，动脉导管未闭返流血量少，经二级以上医院专科检查确定无须手术者除外)、心肌病、高血压病。</br>
      2.重症支气管扩张、哮喘，恶性肿瘤、慢性肾炎、尿毒症。</br>
      3.严重的血液、内分泌及代谢系统疾病、风湿性疾病。</br>
      4.重症或难治性癫痫或其他神经系统疾病；严重精神病未治愈、精神活性物质滥用和依赖。</br>
      5.慢性肝炎病人并且肝功能不正常者(肝炎病原携带者但肝功能正常者除外)。</br>
      6.结核病除下列情况外可以不予录取：</br>
      (1)原发型肺结核、浸润性肺结核已硬结稳定；结核型胸膜炎已治愈或治愈后遗有胸膜肥厚者；</br>
      (2)一切肺外结核(肾结核、骨结核、腹膜结核等)、血行播散型肺结核治愈后一年以上未复发，经二级以上医院(或结核病防治所)专科检查无变化者；</br>
      (3)淋巴腺结核已临床治愈无症状者。</br>
      <h4>三、	患有下列疾病者，学校有关专业可不予录取</h4>
      1.轻度色觉异常(俗称色弱)不能录取的专业：以颜色波长作为严格技术标准的化学类、化工与制药类、药学类、生物科学类、公安技术类、地质学类各专业，医学类各专业；生物工程、生物医学工程、动物医学、动物科学、野生动物与自然保护区管理、心理学、应用心理学、生态学、侦查学、特种能源工程与烟火技术、考古学、海洋科学、海洋技术、轮机工程、食品科学与工程、轻化工程、林产化工、农学、园艺、植物保护、茶学、林学、园林、蚕学、农业资源与环境、水产养殖学、海洋渔业科学与技术、材料化学、环境工程、高分子材料与工程、过程装备与控制工程、学前教育、特殊教育、体育教育、运动训练、运动人体科学、民族传统体育各专业。</br>
      2.色觉异常Ⅱ度(俗称色盲)不能录取的专业，除同轻度色觉异常外，还包括美术学、绘画、艺术设计、摄影、动画、博物馆学、应用物理学、天文学、地理科学、应用气象学、材料物理、矿物加工工程、资源勘探工程、冶金工程、无机非金属材料工程、交通运输、油气储运工程等专业。专科专业：与以上专业相同或相近的专业。</br>
      3.不能准确识别红、黄、绿、蓝、紫各种颜色中任何一种颜色的导线、按键、信号灯、几何图形者不能录取的专业：除同轻度色觉异常、色觉异常Ⅱ度两类列出专业外，还包括经济学类、管理科学与工程类、工商管理类、公共管理类、农业经济管理类、图书档案学类各专业。不能准确在显示器上识别红、黄、绿、蓝、紫各颜色中任何一种颜色的数码、字母者不能录取到计算机科学与技术等专业。</br>
      4.裸眼视力任何一眼低于5.0者，不能录取的专业：飞行技术、航海技术、消防工程、刑事科学技术、侦察。专科专业：海洋船舶驾驶及与以上专业相同或相近的专业(如民航空中交通管制)。</br>
      5.裸眼视力任何一眼低于4.8者，不能录取的专业：轮机工程、运动训练、民族传统体育。专科专业：烹饪与营养、烹饪工艺等。</br>
      <h4>四、	患有下列疾病不宜就读的专业</h4>
      1.主要脏器：肺、肝、肾、脾、胃肠等动过较大手术，功能恢复良好，或曾患有心肌炎、胃或十二指肠溃疡、慢性支气管炎、风湿性关节炎等病史，甲状腺功能亢进已治愈一年的，不宜就读地矿类、水利类、交通运输类、能源动力类、公安学类、体育学类、海洋科学类、大气科学类、水产类、测绘类、海洋工程类、林业工程类、武器类、森林资源类、环境科学类、环境生态类、旅游管理类、草业科学类各专业，及土木工程、消防工程、农业水利工程、农学、法医学、水土保持与荒漠化防治、动物科学各专业。专科专业不宜就读烹饪工艺、西餐工艺、面点工艺、烹饪与营养、表演、舞蹈学、雕塑、考古学、地质学、建筑工程、交通土建工程、工业设备安装工程、铁道与桥梁工程、公路与城市道路工程、公路与桥梁工程、铁道工程、工业与民用建筑工程各专业。</br>
      2.先天性心脏病经手术治愈，或房室间隔缺损分流量少，动脉导管未闭返流血量少，经二级以上医院专科检查确定无须手术者不宜就读的专业同第三部分第一条。</br>
      3.肢体残疾(不继续恶化)，不宜就读的专业同第三部分第一条。</br>
      4.屈光不正(近视眼或远视眼，下同)任何一眼矫正到4.8、镜片度数大于400度的，不宜就读海洋技术、海洋科学、测控技术与仪器、核工程与核技术、生物医学工程、服装设计与工程、飞行器制造工程。专科专业：与以上相同或相近的专业。</br>
      5.任何一眼矫正到4.8、镜片度数大于800度的，不宜就读地矿类、水利类、土建类、动物生产类、水产类、材料类、能源动力类、化工与制药类、武器类、农业工程类、林业工程类、植物生产类、森林资源类、环境生态类、医学类、心理学类、环境与安全类、环境科学类、电子信息科学类、材料科学类、地质学类、大气科学类及地理科学、测绘工程、交通工程、交通运输、油气储运工程、船舶与海洋工程、生物工程、草业科学、动物医学各专业。专科专业：与以上相同或相近的专业。</br>
      6.一眼失明，另一眼矫正到4.8、镜片度数大于400度的，不宜就读工学、农学、医学、法学各专业及应用物理学、应用化学、生物技术、地质学、生态学、环境科学、海洋科学、海洋技术、生物科学、应用心理学等专业。</br>
      7.两耳听力均在3m以内，或一耳听力在5m另一耳全聋的，不宜就读法学各专业、外国语言文学各专业以及外交学、新闻学、侦查学、学前教育、音乐学、录音艺术、土木工程、交通运输、动物科学、动物医学各专业、医学各专业。</br>
      8.嗅觉迟钝、口吃、步态异常、驼背、面部疤痕、血管瘤、黑色素痣、白癜风的，不宜就读教育学类、公安学类各专业以及外交学、法学、新闻学、音乐表演、表演各专业。</br>
      9.斜视、嗅觉退钝、口吃不宜就读医学类专业。</br>
      此部分内容供考生在报考专业志愿时参考。学校不得以此为依据，拒绝录取达到相关要求的考生。</br>
      <h4>五、其他</h4>
      1.未列入专业目录或经教育部批准有权自定新的学科专业，学校招生时可根据专业性质、特点，提出学习本专业对身体素质、生理条件的要求，并在招生章程中明确刊登，做好咨询解释工作。</br>
      2.公安类普通高等学校招生体检按公政治﹝2000﹞137号文件执行。</br>
      3.中国人民解放军院校招收学员体格检查标准按2023年3月16日起施行的《军队选拔军官和文职人员体检标准》为准。2016 年6月20日军委政治工作部、后勤保障部、训练管理部印发的《军队院校招收学员体格检查标准》《军队院校招收学员体格检查办法》同时废止。</br>
    </div>
  </el-dialog>
</template>
<script>

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '普通高等学校招生体检工作指导意见'
    },
  },
  data() {
    return {
      infos: {},
      tijianLimitTitle: '普通高等学校招生体检工作指导意见',
    }
  },
  computed: {
    // 弹窗是否可见
    isVisible: {
      get() {
        return this.dialogVisible
      },
      set() {
        this.close()
        this.reset()
      }
    },
  },
  created() {
    this.infos = this.$route.params.info
    this.infos = JSON.parse(sessionStorage.getItem("user"))
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
